import { CentraCheckoutApiProductItem } from "@made-people/centra-checkout-api";
import { CentraCheckoutApiMappers } from "@made-people/grease-centra";
import { ProductVariantDimension } from "@made-people/grease-product";
import { getLocalizedItemSize } from "./utils/get-localized-item-size";
import { getTableMappingIdForCountryCode } from "./utils/get-table-mapping-id-for-country-code";

export const mmProductVariantDimensions: CentraCheckoutApiMappers["centraCheckoutApiProductItemToGreaseProductVariantDimensions"] =
  (item, product, options) => {
    const parser = options.productOptions.itemDimensionParseOptions;

    if (!parser) {
      return [createDefaultDimension(item)];
    }

    // Check if we have a table mapping for localization
    const tableMappingId = getTableMappingIdForCountryCode(
      options.context.countryCode,
    );

    // Get the table mapping from the product if available
    const tableMapping = product.tableMappings?.[tableMappingId];

    // If we have a table mapping, use it to localize the size, otherwise use the default size
    const localizedSizeLabel = tableMapping
      ? getLocalizedItemSize(item.name, tableMapping)
      : item.name;

    const dimensions = localizedSizeLabel.split(
      product.itemTable.dividerSymbol,
    );

    // If there is only one dimension, there is no match for the delimiter
    // and we use the default dimension key and label.
    if (dimensions.length === 1) {
      return [createDimensionFromValue(localizedSizeLabel, undefined)];
    }

    return dimensions.map((value, index) =>
      createDimensionFromValue(value, parser.dimensionInfo[index]),
    );
  };

const DEFAULT_DIMENSION_KEYS = {
  key: "size",
  label: "Item_Dimension_Size",
};

const createDefaultDimension = (
  item: CentraCheckoutApiProductItem,
): ProductVariantDimension => ({
  // Add item.item as value in default dimension so that quick add to cart is supported
  value: item.item,
  valueLabel: item.name,
  dimensionKey: DEFAULT_DIMENSION_KEYS.key,
  dimensionLabel: DEFAULT_DIMENSION_KEYS.label,
});

const createDimensionFromValue = (
  value: string,
  dimensionInfo: { key: string; label: string } | undefined,
): ProductVariantDimension => ({
  value,
  valueLabel: value,
  dimensionKey: dimensionInfo?.key ?? DEFAULT_DIMENSION_KEYS.key,
  dimensionLabel: dimensionInfo?.label ?? DEFAULT_DIMENSION_KEYS.label,
});
